export default __webpack_public_path__ + "static/media/Banner@2x.b7ed86c8.png";